module.exports = __webpack_public_path__ + "img/horizontal_6_6_9005.25dca26d.png";